module.exports = __webpack_public_path__ + "static/media/teachers-06.035bd7e8.png";